import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-materiales',
  templateUrl: './materiales.component.html',
  styleUrls: []
})
export class MaterialesComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/materiales/materiales.component.ts